import {Action, lazyGet} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {inject, injectable} from "inversify";
import {ISocial} from "@dp-instant/social";
import {SIOConstants} from "@game/constants";
import {GameConfig, TypesCore, TypesDevice} from "@dp-instant/interfaces";
import {IDeviceConfig} from "@dp-instant/game-template";

@injectable()
export class SetCalculatedConstantValuesAction extends Action {
    @inject(TypesSocial.model)
    protected readonly social: ISocial;

    public async execute(): Promise<void> {
        const DEFAULT_OK_BANNER_HEIGHT = 106;

        const canShowBannerOnOk =
            __SOCIAL__ === "ok" &&
            !!lazyGet<GameConfig>(TypesCore.gameConfig)?.useBannerAd &&
            lazyGet<IDeviceConfig>(TypesDevice.model)?.isAndroid;

        if (canShowBannerOnOk) {
            SIOConstants.BANNER_HEIGHT = DEFAULT_OK_BANNER_HEIGHT;
        }
    }
}
